import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    pageNumber: 0,
    currentView: {
      isMobileView: true,
      isTabletView: false,
      isWebView: false,
      windowWidth: 0,
    },

    scrollPosition: 0,
  },
  mutations: {
    SET_PAGE_NUMBER: (state, payload) => {
      state.pageNumber = payload;
    },
    SET_CURRENT_VIEW: (state, payload) => {
      state.currentView.isMobileView = payload.isMobileView;
      state.currentView.isTabletView = payload.isTabletView;
      state.currentView.isWebView = payload.isWebView;
    },
    SET_SCROLL_POSITION: (state, payload) => {
      state.scrollPosition = payload;
    },
    SET_WINDOW_WIDTH: (state, payload) => {
      state.currentView.windowWidth = payload;
    },
  },
  actions: {
    init({ commit }) {
      commit("SET_PAGE_NUMBER", 0);
      commit("windowWidth", window.innerWidth);
    },
    setScrollPosition(context, payload) {
      context.commit("SET_SCROLL_POSITION", payload.scrollPosition);
      if (Math.floor(payload.scrollPosition) != this.state.pageNumber) {
        this.dispatch("setPageNumber", Math.floor(payload.scrollPosition));
      }
    },
    setPageNumber(context, payload) {
      context.commit("SET_PAGE_NUMBER", payload);
    },
    setCurrentView(context, payload) {
      context.commit("SET_CURRENT_VIEW", payload);
    },
    setWindowWidth(context, payload) {
      context.commit("SET_WINDOW_WIDTH", payload);
    },
  },
  getters: {
    getPageNumber: (state) => {
      return state.pageNumber;
    },
    getWindowWidth: (state) => {
      return state.currentView.windowWidth;
    },
    getIsMobileView: (state) => {
      return state.currentView.isMobileView;
    },
    getIsTabletView: (state) => {
      return state.currentView.isTabletView;
    },
    getIsWebView: (state) => {
      return state.currentView.isWebView;
    },
  },
  modules: {},
});
